<template>
  <div class="employee-certification">
    <el-row gutter="20">
      <el-col :offset="2" :span="8">
        <el-form-item label="姓名：" label-width="100px">
          <el-input v-model="formData.employee_name" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :offset="2" :span="8">
        <el-form-item label="工号：" label-width="100px">
          <el-input v-model="formData.employee_no" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :offset="2" :span="8">
        <el-form-item label="部门：" label-width="100px">
          <el-input v-model="formData.department_ids" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :offset="2" :span="8">
        <el-form-item label="可认证数：" label-width="100px">
          <el-input v-model="formData.can_certification_number" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :offset="2" :span="8">
        <el-form-item label="已认证：" label-width="100px">
          <el-input v-model="formData.certified_number" disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :offset="2" :span="8">
        <el-form-item label="百分比：" label-width="100px">
          <el-input v-model="formData.percent" disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- Certification Details -->
    <el-row v-for="(group, index) in certificationGroups" :key="index" gutter="20" class="certification-section">
      <h3>{{ group.title }}</h3>
      <el-col :offset="2" :span="22">
        <el-table :data="group.certification_records" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column label="晋升前置条件" align="center">
            <template #default="scope">
              完成{{ scope.row.short_name }}认证
            </template>
          </el-table-column>
          <el-table-column label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="scope.row.is_certified" disabled></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="certification_date" label="认证日期" width="100" align="center">

          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- Save Button -->
    <el-row>
      <el-col :span="24" class="save-button">
        <el-button type="primary" @click="saveForm">保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "EmployeeSwCertificationRecords",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      formData: {},
      certificationGroups:[]
    };
  },
  methods: {
    headStyle() {
      return {
        'background-color': '#f0f0f0',
      }
    },
    async getData(){
      this.formData.employee_name = this.parentData.employee_name
      this.formData.employee_no = this.parentData.employee_no
      this.formData.department_ids = this.parentData.department_ids
      this.formData.can_certification_number = this.parentData.can_certification_number
      this.formData.certified_number = this.parentData.certified_number
      this.formData.percent = this.parentData.percent
      await this.$http("employeeLevelService.getEmployeeCertificationRecords", this.formData).then(res =>{
        this.certificationGroups = res
        console.log('res:',res)
      })
    }
  },
  created() {
    this.getData()
  }

}
</script>

<style scoped lang="less">
.employee-certification {
  padding: 20px;
}

.certification-section {
  margin-top: 20px;
}

.save-button {
  text-align: center;
  margin-top: 20px;
}
</style>